<template>
    <div role="form">
        <template
            v-if="state.currentView == 'PAYPAL_INIT_VIEW' && state.processing != true"
        >
            <p
                class="container__col-md-12 container__col-sm-12 payment__instruction"
            ></p>
            <PrimaryButton :paypal="true" :content="$t('paypal.init.btn')" @click="Next" />
        </template>
        <div
            v-else-if="
                state.currentView == 'REDIRECT_VIEW' && state.processing != true
            "
        >
            <div class="redirect-wrapper">
                <svg class="paypal-btn__logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 566.93 137.35"><path d="M49.52 32.33h38.74c20.8 0 28.63 10.53 27.42 26C113.68 83.88 98.24 98 77.76 98H67.37c-2.81 0-4.7 1.86-5.46 6.9l-4.39 29.3c-.29 1.9-1.29 3-2.79 3.16H30.39c-2.29 0-3.1-1.75-2.51-5.54l14.84-93.93c.59-3.77 2.65-5.56 6.8-5.56z" fill="#009ee3" fill-rule="evenodd"></path><path d="M217.66 30.59c13.07 0 25.13 7.09 23.48 24.77-2 21-13.25 32.62-31 32.67h-15.5c-2.23 0-3.31 1.81-3.89 5.55l-3 19.07c-.45 2.88-1.93 4.31-4.12 4.31H169.2c-2.3 0-3.1-1.48-2.59-4.76l11.91-76.45c.59-3.76 2-5.16 4.57-5.16zm-23.51 40.92h11.75c7.35-.28 12.24-5.37 12.73-14.55.3-5.67-3.53-9.73-9.62-9.7l-11.07.05-3.79 24.19zm86.21 39.58c1.32-1.19 2.66-1.82 2.47-.34l-.47 3.54c-.24 1.85.49 2.84 2.22 2.84h12.81c2.16 0 3.21-.88 3.75-4.21l7.9-49.59c.39-2.49-.21-3.71-2.1-3.71h-14.1c-1.27 0-1.88.72-2.22 2.66l-.52 3.05c-.27 1.59-1 1.87-1.68.26-2.39-5.66-8.49-8.2-17-8-19.78.4-33.11 15.41-34.53 34.66-1.11 14.88 9.56 26.57 23.62 26.57 10.19 0 14.76-3 19.89-7.71zm-10.73-7.63c-8.51 0-14.44-6.79-13.2-15.11s9.19-15.11 17.7-15.11 14.44 6.78 13.21 15.11-9.19 15.11-17.71 15.11zm64.51-44h-12.95c-2.69 0-3.78 2-2.92 4.46l16.14 47.27-15.89 22.48c-1.32 1.87-.3 3.59 1.57 3.59h14.61a4.49 4.49 0 004.35-2.13l49.63-71.21c1.53-2.19.81-4.48-1.7-4.49h-13.83c-2.37 0-3.32.93-4.68 2.91l-20.71 30-9.24-30.06c-.54-1.82-1.89-2.82-4.38-2.82z" fill="#113984" fill-rule="evenodd"></path><path d="M440.32 30.59c13.08 0 25.14 7.09 23.48 24.77-1.95 21-13.25 32.62-31 32.67h-15.5c-2.23 0-3.31 1.81-3.89 5.55l-3 19.07c-.46 2.88-1.93 4.31-4.12 4.31h-14.42c-2.3 0-3.1-1.48-2.59-4.76l11.93-76.45c.58-3.76 2-5.16 4.57-5.16zm-23.5 40.92h11.75c7.35-.28 12.24-5.37 12.73-14.55.3-5.67-3.53-9.73-9.63-9.7l-11.06.05-3.79 24.19zm86.21 39.58c1.32-1.19 2.66-1.82 2.47-.34l-.47 3.54c-.25 1.85.49 2.84 2.21 2.84h12.82c2.16 0 3.21-.88 3.74-4.21l7.9-49.59c.4-2.49-.2-3.71-2.1-3.71h-14.08c-1.27 0-1.89.72-2.22 2.66l-.52 3.05c-.27 1.59-1 1.87-1.68.26-2.39-5.66-8.49-8.2-17.05-8-19.77.4-33.1 15.41-34.53 34.66-1.1 14.88 9.57 26.57 23.62 26.57 10.2 0 14.76-3 19.9-7.71zm-10.73-7.63c-8.51 0-14.44-6.79-13.2-15.11s9.19-15.11 17.7-15.11 14.44 6.78 13.2 15.11-9.19 15.11-17.7 15.11zm59.13 13.74h-14.79a1.75 1.75 0 01-1.82-2.05l13-82.36a2.56 2.56 0 012.46-2h14.8a1.74 1.74 0 011.81 2l-13 82.36a2.55 2.55 0 01-2.46 2.07z" fill="#009ee3" fill-rule="evenodd"></path><path d="M25.24 0h38.79C74.95 0 87.9.36 96.57 8c5.79 5.11 8.83 13.24 8.13 22-2.38 29.61-20.1 46.2-43.85 46.2H41.72c-3.25 0-5.41 2.15-6.33 8l-5.34 33.95c-.34 2.2-1.3 3.5-3 3.66H3.12c-2.65 0-3.59-2-2.9-6.42L17.42 6.46C18.11 2.08 20.52 0 25.24 0z" fill="#113984" fill-rule="evenodd"></path><path d="M35.95 80.75l6.77-42.86c.59-3.77 2.65-5.56 6.75-5.56h38.74c6.41 0 11.6 1 15.66 2.85-3.9 26.35-20.94 41-43.27 41H41.52c-2.56 0-4.44 1.28-5.57 4.57z" fill="#172c70" fill-rule="evenodd"></path></svg>
            </div>
            <p class="container__col-md-12 container__col-sm-12 payment__instruction">
                {{$t("paypal.redirect.instruction")}}
            </p>
            <PrimaryButton
                :content="state.error != null ? $t('paypal.retry.btn') : $t('paypal.redirect.btn')"
                @click="Next"
            />
        </div>
    </div>
</template>

<script>
import { ref, onBeforeUnmount } from "vue";
import { injectStore, mapState } from "redux-vuex";
import { getValueFromPath } from "@/support/helpers";

import PrimaryButton from "@/components/form/base-button";

export default {
    name: "PayPalPayment",
    components: {
        PrimaryButton,
    },

    setup() {
        const store = injectStore();
        const checkoutData = ref(store.getState());
        const subscription = store.subscribe(() => {
            checkoutData.value = store.getState();
        });
        function Next() {
            setTimeout(() => {
                checkoutData.value.view.context.$actions.next();
            }, 0);
        }
        if ( checkoutData.value.processing != true &&
           checkoutData.value.view != undefined &&
            checkoutData.value.view.current == "PAYPAL_INIT_VIEW"
        ) {
            Next();
        }

        onBeforeUnmount(() => {
            subscription();
        });
        return {
            state: mapState({
                error: (state) => getValueFromPath(state, "error") || null,
                processing: (state) => getValueFromPath(state, "processing") || false,
                currentView: (state) => getValueFromPath(state, "view.current") || null,
                inputs: (state) => getValueFromPath(state, "view.context.inputs") || {},
            }),
            checkoutData,
            getValueFromPath,
            Next,
        };
    },
};
</script>
<style lang="scss">
.barter-or {
  display: flex;
  text-align: center;
  justify-content: center;
  align-items: center;
  margin: 34px 0;
  color: #8b8b8b;
  &::before,
  &::after {
    content: "";
    display: block;
    width: 160px;
    border-bottom: 0.946925px solid #e4ecf3;
  }
  label {
    font-size: 14px;
    line-height: 14px;
    margin: 0 10px;
  }
}
.redirect-wrapper{
    margin-bottom: 1.3rem;
}
</style>